import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { GetAgencyStatisticsResponse } from '@nxsys/types/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { useState } from 'react';
import AgencyEmployeeModal, {
  AgencyEmployeeModalTypeEnum,
} from './components/AgencyEmployeeModal';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

type Props = {
  loading: boolean;
  data?: GetAgencyStatisticsResponse['data']['registrations'];
  agencyId: string;
};

const AgencyRegistration: React.FC<Props> = ({ loading, data, agencyId }) => {
  const { messages } = useTypedIntl();
  const [isOpenEmployeeModal, setIsOpenEmployeeModal] = useState(false);
  const [employeeModalType, setEmployeeModalType] =
    useState<AgencyEmployeeModalTypeEnum | null>(null);

  const handleOpenEmployeeModal = (type: AgencyEmployeeModalTypeEnum) => {
    setEmployeeModalType(type);
    setIsOpenEmployeeModal(true);
  };

  const items = [
    {
      title: data?.totalSubcontractors,
      description: messages['common.totalEmployees'],
      icon: (
        <Icons.IconUserGroup color={defaultTheme.theme.palette.primary[500]} />
      ),
      onClick: () => handleOpenEmployeeModal(AgencyEmployeeModalTypeEnum.TOTAL),
    },
    {
      title: data?.totalPendingRegistrations,
      description: 'Pending Registration',
      icon: (
        <Icons.IconUserMinus color={defaultTheme.theme.palette.primary[500]} />
      ),
      onClick: () =>
        handleOpenEmployeeModal(
          AgencyEmployeeModalTypeEnum.PENDING_REGISTRATION,
        ),
    },
    {
      title: data?.totalSubcontractorsRegistered,
      description: 'Registered',
      icon: (
        <Icons.IconUserPlus color={defaultTheme.theme.palette.primary[500]} />
      ),
      onClick: () =>
        handleOpenEmployeeModal(AgencyEmployeeModalTypeEnum.REGISTERED),
    },
  ];

  return (
    <div className="OnHold">
      <AppCard className="p-[24px]" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconDocs" title={messages['common.employees']} />
        </div>
        <div className="grid grid-cols-3 gap-[16px] max-sm:grid-cols-1">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px]"
              onClick={item.onClick}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[18px]">
                <div className="bg-primary-50 rounded-[8px] p-[8px]">
                  {item.icon}
                </div>
                <Icons.IconArrowRight />
              </div>
              <div className="text-[22px] font-bold mb-[8px]">{item.title}</div>
              <div className="text-[14px] font-bold">{item.description}</div>
            </div>
          ))}
        </div>
      </AppCard>
      {employeeModalType && (
        <AgencyEmployeeModal
          isOpen={isOpenEmployeeModal}
          toggle={() => setIsOpenEmployeeModal(false)}
          type={employeeModalType}
          agencyId={agencyId}
        />
      )}
    </div>
  );
};

export default AgencyRegistration;
